const CURSOR_GAP = 12;
const VIEWPORT_MARGIN = 8;

const placeAlongAxis = (
  cursor: number,
  contentSize: number,
  viewportSize: number,
) => {
  const spaceAfter = viewportSize - cursor - CURSOR_GAP - VIEWPORT_MARGIN;
  const spaceBefore = cursor - CURSOR_GAP - VIEWPORT_MARGIN;
  const placeAfter = spaceAfter >= contentSize || spaceAfter >= spaceBefore;
  const start = placeAfter
    ? cursor + CURSOR_GAP
    : cursor - CURSOR_GAP - contentSize;
  const maxStart = viewportSize - contentSize - VIEWPORT_MARGIN;
  return Math.max(VIEWPORT_MARGIN, Math.min(start, maxStart));
};

export const computeTooltipPosition = (
  [cursorX, cursorY]: [number, number],
  [contentWidth, contentHeight]: [number, number],
  containerLeft: number,
  containerTop: number,
): [number, number] => {
  const left = placeAlongAxis(
    containerLeft + cursorX,
    contentWidth,
    window.innerWidth,
  );
  const top = placeAlongAxis(
    containerTop + cursorY,
    contentHeight,
    window.innerHeight,
  );
  return [left - containerLeft, top - containerTop];
};
